import PropTypes from 'prop-types';
import React from 'react';

function AccountIcon({title, loggedIn = false}) {
  return (
    <svg className="account-icon icon" id="account-icon" viewBox="0 0 78 70" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <g fillRule="evenodd">
       <path className="account" d="M32 40C21.4 40 0 45.4 0 56v8h64v-8c0-10.6-21.4-16-32-16m0-8c8.8 0 16-7.2 16-16S40.8 0 32 0 16 7.2 16 16s7.2 16 16 16"/>
       { loggedIn && <ellipse className="tick-circle" cx="57.261" cy="48.047" rx="18.261" ry="19.047"/>}
       { loggedIn && <path className="tick" d="M64.847 39.62l-10.7 10.7-3.994-3.995L47 49.478l7.147 7.14.918-.917h.006L68 42.773"/>}
      </g>
    </svg>
  );
}

AccountIcon.propTypes = {
  title: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool
}

export default AccountIcon



// WEBPACK FOOTER //
// ./modules/Common/components/svg/AccountIcon.js